import { LegalPageLayout } from "../components/legal/LegalPageLayout";

/**
 * Impressum — German legal disclosure page (§5 TMG, §18 MStV)
 *
 * Current form: Einzelunternehmen (sole proprietorship) — pre-GmbH registration.
 *
 * ⚠ §5 TMG GAP — the full ladungsfaehige Anschrift (street + postal code) is
 * intentionally omitted at operator's decision (2026-04-17) pending a
 * Geschaeftsadresse / virtual office. City + country + LinkedIn + e-mail only.
 * This is NOT §5 TMG compliant and carries Abmahnung risk until resolved. Fix
 * ASAP by registering a ladungsfaehige Anschrift and reinstating street + PLZ.
 *
 * Once the GmbH is registered, replace this file with the full version including
 * HRB number, Geschaeftsfuehrer, and (if applicable) USt-IdNr.
 */
export function Impressum() {
  return (
    <LegalPageLayout
      title="Impressum"
      lastUpdated="17. April 2026"
      crossLink={{ to: "/privacy", label: "Datenschutzerklaerung" }}
      contactEmail="contact@chargesuite.de"
    >
      <section>
        <h2>Angaben gemaess §5 TMG</h2>
        <div className="legal-block">
          <p>
            <strong>ChargeSuite</strong>
            <br />
            Einzelunternehmen, Inhaber: Piotr Jerzy Jania
            <br />
            Frankfurt am Main, Deutschland
          </p>
        </div>
      </section>

      <section>
        <h2>Kontakt</h2>
        <div className="legal-block">
          <p>
            <strong>E-Mail:</strong>{" "}
            <a href="mailto:contact@chargesuite.de">contact@chargesuite.de</a>
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a href="https://chargesuite.de" target="_blank" rel="noopener noreferrer">
              chargesuite.de
            </a>
          </p>
          <p>
            <strong>LinkedIn:</strong>{" "}
            <a
              href="https://www.linkedin.com/company/chargesuite-de/"
              target="_blank"
              rel="noopener noreferrer"
            >
              linkedin.com/company/chargesuite-de
            </a>
          </p>
        </div>
      </section>

      <section>
        <h2>Umsatzsteuer-Identifikationsnummer</h2>
        <div className="legal-block">
          <p>Umsatzsteuer-IdNr. gemaess §27a UStG: noch nicht erteilt.</p>
        </div>
      </section>

      <section>
        <h2>Verantwortlich fuer den Inhalt nach §18 Abs. 2 MStV</h2>
        <div className="legal-block">
          <p>
            Piotr Jerzy Jania
            <br />
            Frankfurt am Main, Deutschland
            <br />
            <a href="mailto:contact@chargesuite.de">contact@chargesuite.de</a>
          </p>
        </div>
      </section>

      <section>
        <h2>EU-Streitschlichtung</h2>
        <div className="legal-block">
          <p>
            Die Europaeische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
          </p>
          <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
        </div>
      </section>

      <section>
        <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
        <div className="legal-block">
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>
      </section>

      <section>
        <h2>Haftung fuer Inhalte</h2>
        <div className="legal-block">
          <p>
            Als Diensteanbieter sind wir gemaess §7 Abs. 1 TMG fuer eigene Inhalte auf diesen Seiten nach
            den allgemeinen Gesetzen verantwortlich. Nach §§8 bis 10 TMG sind wir als Diensteanbieter
            jedoch nicht verpflichtet, uebermittelte oder gespeicherte fremde Informationen zu ueberwachen
            oder nach Umstaenden zu forschen, die auf eine rechtswidrige Taetigkeit hinweisen.
          </p>
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
            allgemeinen Gesetzen bleiben hiervon unberuehrt. Eine diesbezuegliche Haftung ist jedoch
            erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung moeglich. Bei
            Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
        </div>
      </section>

      <section>
        <h2>Urheberrecht</h2>
        <div className="legal-block">
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
            deutschen Urheberrecht. Die Vervielfaeltigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung ausserhalb der Grenzen des Urheberrechtes beduerfen der schriftlichen Zustimmung
            des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur fuer den
            privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
        </div>
      </section>
    </LegalPageLayout>
  );
}
